import { HStack, Pressable, VStack } from "@gluestack-ui/themed";
import { Icon } from "@repo/core/components/core/Icon";
import { InputDatePicker } from "@repo/core/components/core/InputDatePicker";
import { Text } from "@repo/core/components/core/Text";
import { ReportScreenHeaderProps } from "./types";
import { MustShow } from "@repo/core/components/core/MustShow";
import { ReportScreenHeaderController } from "./controller";

export const ReportScreenHeader = ({
  defaultStartDate,
  defaultEndDate,
  onChangeStartDate,
  onChangeEndDate,
  reportTypes,
  selectedReportType,
  onSelectReportType,
  handleSelectFilter
}: ReportScreenHeaderProps) => {
  const { fetchedAtText, isMobile } = ReportScreenHeaderController();
  return (
    <HStack
      justifyContent="space-between"
      flexDirection={isMobile ? "column" : "row"}
      px={isMobile ? "$4" : 0}
    >
      <VStack flex={1}>
        <Text fontSize="$sm" fontWeight={500} color="$textLight800">
          Periodo
        </Text>
        <HStack
          $md-w="85%"
          $xl-w="85%"
          $base-w="100%"
          space="lg"
          justifyContent="center"
          alignItems="flex-end"
        >
          <InputDatePicker
            onChangeDate={onChangeStartDate}
            defaultValue={defaultStartDate}
          />
          <InputDatePicker
            onChangeDate={onChangeEndDate}
            defaultValue={defaultEndDate}
          />

          <Pressable
            w="$12"
            h="$12"
            justifyContent="center"
            alignItems="center"
            bg="$white"
            borderWidth={1}
            borderColor="$primary700_50"
            borderRadius="$lg"
            onPress={handleSelectFilter}
          >
            <Icon name="filter" color="$primary700" size={20} variant="solid" />
          </Pressable>
        </HStack>
      </VStack>
      <VStack
        mt={isMobile ? "$3" : 0}
        justifyContent="center"
        alignItems={isMobile ? "center" : "flex-end"}
        gap="$2"
      >
        <HStack alignItems="center" gap="$1">
          <Icon name="alert-circle" color="$warning600" size={16} />
          <Text fontSize="$xs" color="$textLight700">
            Verifique se a loja selecionada acima está correta.
          </Text>
        </HStack>
        <MustShow isVisible={reportTypes && reportTypes?.length > 1}>
          <HStack bg="$backgroundLight100" w="$full">
            {reportTypes?.map((reportType) => (
              <Pressable
                flex={1}
                minWidth={160}
                bg={
                  selectedReportType === reportType.type
                    ? "white"
                    : "$transparent"
                }
                key={reportType.type}
                onPress={() => onSelectReportType?.(reportType.type)}
                borderRadius="$md"
                p="$1"
                justifyContent="center"
                alignItems="center"
              >
                <Text
                  fontSize="$sm"
                  color={
                    selectedReportType === reportType.type
                      ? "#0A0A0A"
                      : "#737373"
                  }
                  p="$2"
                >
                  {reportType.title}
                </Text>
              </Pressable>
            ))}
          </HStack>
        </MustShow>
      </VStack>

      <MustShow isVisible={isMobile}>
        <HStack gap="$2" alignItems="center" justifyContent="center" my="$4">
          <Text fontSize="$2xs" color="$secondary600">
            {fetchedAtText}
          </Text>

          <Pressable>
            <Icon name="refresh" size={16} color="$secondary600" />
          </Pressable>
        </HStack>
      </MustShow>
    </HStack>
  );
};
